import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Modal, Form } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faPaperclip, faEye, faSpinner, faLocationDot, faCircleCheck, faChevronDown, faGear, faRotateRight } from '@fortawesome/free-solid-svg-icons';
import Slider from "react-slick";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';

import Docmnt from '../../../../assets/images/google-docs.png';
import Cargoplane from "../../../../assets/images/plane.svg";
import Export from "../../../../assets/images/export.svg";
import edit from "../../../../assets/images/edit.png";
import Loading from "../../../../assets/images/loading.png";
import Unloading from "../../../../assets/images/Unloading.png";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import ImageUpload from '../../../../Components/common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';
import Rapdf from "../../../../assets/images/pdf.png";
import pen from "../../../../assets/images/pen.png";
import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';
const VehicleView = () => {

    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const [filterApplied, setFilterApplied] = useState(false);
    const [activeTab, setActiveTab] = useState('All');
    const [gridData, setGridData] = useState([]);

    const [selectedRowData, setSelectedRowData] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);
    const gridRefs = {
        All: useRef(null),
        Loading: useRef(null),
        Unloading: useRef(null),
        Archived: useRef(null),
    };

    useEffect(() => {
        if (isMounted.current) return;
        // Call the fetchData function to fetch data from the API
        // fetchDataGrid();
        setIsLoading(false);
        setGridData([]);
        isMounted.current = true;
    }, []);

    const handleTabChange = async (tab) => {
        setActiveTab(tab);
        setIsLoading(true);
        setFilterApplied(false);
        if (selectedRowData) {
            setSelectedRowData(null)
        }
        setGridSelect([]);
        if (tab == 'All') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ All: {} });
            }, 1);
        } else if (tab == 'Loading') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Loading: {} });
            }, 1);
        } else if (tab == 'Unloading') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Unloading: {} });
            }, 1);
        } else {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Archived: {} });
            }, 1);
        }
    };

    let checkUlds = [];
    let filterForCheck = false;
    const [applyFilter, setApplyFilter] = useState({});

    const stationData = JSON.parse(localStorage.getItem('Handler_stn'));
    // const tabName = localStorage.getItem('spl_lu');
    useEffect(() => {
        if (gridRefs[activeTab].current) {
            let tabType = '';
            let tabName = '';
            switch (activeTab) {
                case 'Loading':
                    tabType = 'A';
                    tabName = activeTab;
                    break;
                case 'Unloading':
                    tabType = 'A';
                    tabName = activeTab;
                    break;
                case 'Archived':
                    tabType = 'I';
                    tabName = 'All';
                    break;
                default:
                    tabType = 'All';
                    tabName = activeTab;
                    break;
            }
            // var token = "Bearer " + (localStorage.RFS || localStorage.Trucking || '');
            jqxCookieCall();
            const source = {
                // url: `${process.env.REACT_APP_RFS_URL}trip-view-list?tab_name=${tabName}&station=${stationData.station_name}&activity_status=${tabType}`,
                // url: `${process.env.REACT_APP_RFS_URL}monitor/vehicle-view-list?tab_name=${tabName}&station=${stationData.station_name}&activity_status=${tabType}`,
                url: `${process.env.REACT_APP_RFS_URL}handler-trip-view-list?tab_name=${tabName}&station=${stationData.station_name}&activity_status=${tabType}`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                datatype: 'json',
                id: '',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'vehicle_no', type: 'string' },
                    { name: 'planned_date_time', type: 'string' },
                    { name: 'triplist', type: 'string' },
                    { name: 'pickup_status', type: 'string' },
                    { name: 'orders_count', type: 'string' },
                    { name: 'shipments_number', type: 'string' },
                    { name: 'driver_name', type: 'string' },
                    { name: 'truck_nos', type: 'string' },
                    { name: 'trucker_name', type: 'string' },
                    { name: 'order_type', type: 'string' },
                    { name: 'station', type: 'string' },
                    { name: 'gate_in', type: 'string' },
                    { name: 'gate_out', type: 'string' },
                    { name: 'gate_in', type: 'string' },
                    { name: 'gate_out', type: 'string' },
                    { name: 'order_no', type: 'string' },
                    { name: 'door_no', type: 'string' },
                    { name: 'time_slot', type: 'string' },
                    { name: 'warehouse', type: 'string' },
                    { name: 'vehicle_id', type: 'string' },
                    { name: 'trip_no', type: 'string' },
                ],
                filter: function (allfilters) {
                    window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
                    setGridSelect([]);

                    if (allfilters.length > 0) {
                        console.log("Filter Applied");
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        console.log("Filter Cleared");
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");
                },
                beforeprocessing: function (data) {
                    const normalizedRows = data.Rows.map(item => {
                        const trip = item.trip || {};
                        const orders = item.order_shippings || [];
                        const warehouse = item.warehouse || {};
                        const door = item.door || {};
                        const slots = item.slots || [];
                        const normalizedOrders = orders.map(os => {
                            const order = os.order || {};
                            return {
                                order_no: order.order_no,
                                trucker_name: os?.organization?.org_Name,
                                truck_no: order.truck_no,
                                truck_date: order.truck_dated,
                                doc_status: os.doc_statusd,
                                loading_advice: order.loading_advice,
                                pickup_status: [],
                                order_type: item.shipping_type === 'U' ? 'Unloading' : 'Loading',
                                eta_truck: os.eta_truck,
                                awb: (order.order_awbs || []).map(awb => ({
                                    airway_bill: awb.airway_bill,
                                    pieces: awb.pieces,
                                    weight: awb.weight,
                                    volume: awb.volume,
                                    lm: awb.lm,
                                    rcf: awb.rcf,
                                    man: awb.man,
                                    msca: awb.msca,
                                    package: awb.package,
                                    uld_number: awb.uld_number,
                                    nature_of_goods: awb.nature_of_goods,
                                    pickup_status: [],
                                    order_type: ''
                                }))
                            };
                        });
                        return {
                            id: item.id,
                            trip_no: trip.trip_no,
                            vehicle_id: trip.id,
                            vehicle_no: trip.vehicle_license,
                            triplist: trip.triplist,
                            driver_name: trip.driver_name,
                            trucker_name: item.trucker_org.org_Name,
                            carrier_name: '',
                            order_type: item.shipping_type === 'U' ? 'Unloading' : 'Loading',
                            planned_date_time: item.planned_date_time,
                            gate_in: item.gate_in,
                            gate_out: item.gate_out,
                            eta_truck: item.eta_truck,
                            truck_nos: item.truck_nos,
                            orders_count: normalizedOrders.length,
                            station: item.station,
                            door_no: door.door_no,
                            time_slot: item.slot_time,
                            warehouse: warehouse.name,
                            pickup_status: item.pickup_status,
                            orders: normalizedOrders
                        };
                    });
                    data.Rows = normalizedRows;
                    source.totalrecords = data.TotalRows;
                },
                sort: function () {
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                { text: 'Truck No.', filtertype: 'textbox', datafield: 'truck_nos', width: '12%', cellclassname: '', },
                { text: 'Vehicle No.', filtertype: 'textbox', datafield: 'vehicle_no', width: '6%', cellclassname: '', },
                { text: 'Driver Name', filtertype: 'textbox', datafield: 'driver_name', width: '12%', cellclassname: '', },
                {
                    text: 'Triplist', filterable: false, datafield: 'triplist', width: '4%', cellclassname: '',
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        if (cellValue) {
                            defaultHtml = "<div style='line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
                        }
                        return (
                            defaultHtml
                        );
                    },
                },
                { text: 'Orders', filterable: false, datafield: 'orders_count', width: '4%', cellclassname: '', },
                { text: 'Trucker Name', filtertype: 'textbox', datafield: 'trucker_name', width: '6%', cellclassname: '', },
                {
                    text: 'Pickup Status', datafield: 'pickup_status', width: '12%', filterable: false,
                    cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties) => {
                        if (value && Array.isArray(value)) {
                            const content = value
                                .map((item) =>
                                    `<div class="${item.color_status || ''}">${item.status || ''}</div>`
                                ).join('');

                            return `<div class="stats_view">${content}</div>`;
                        }
                        return defaulthtml;
                    }
                },
                {
                    text: 'Order Type', filtertype: 'checkedlist', datafield: 'order_type', width: '6%', cellclassname: '',
                    filteritems: [
                        { label: 'Loading', value: 'Loading' },
                        { label: 'Unloading', value: 'Unloading' },
                    ],
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        if (cellValue === 'Loading') {
                            return '<div class="m_loading"> <img src="' + Loading + '"/> ' + cellValue + ' </div>';
                        } else if (cellValue === 'Unloading') {
                            return '<div class="m_unloading"><img src="' + Unloading + '"/> ' + cellValue + ' </div>';
                        } else {
                            return '';
                        }
                    },
                },
                { text: 'Warehouse', filtertype: 'textbox', datafield: 'warehouse', width: '8%', cellclassname: '', },
                { text: 'Door', filtertype: 'textbox', datafield: 'door_no', width: '4%', cellclassname: 'text-center', },
                { text: 'Time Slot', filtertype: 'textbox', datafield: 'time_slot', width: '16%', cellclassname: '', },
                { text: 'Planning Date', filtertype: 'range', cellsformat: 'dd-MM-yyyy', datafield: 'planned_date_time', width: '8%', cellclassname: '', },
                { text: 'Trip No.', filtertype: 'textbox', datafield: 'trip_no', width: '12%', cellclassname: '', },
                { text: 'Station', filtertype: 'textbox', datafield: 'station', width: '8%', cellclassname: '', },






                // {
                //     text: 'Gate In', filtertype: 'textbox', width: '6%', cellclassname: '', datafield: 'gate_in',
                //     cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, data) {
                //         if (cellValue) {
                //             defaultHtml = '<div style="margin-top: 12px; margin-left:5px">' + cellValue.slice(0, 16) + '<span class="screen" data-type="edit" data-for="gate_in"><img src="' + pen + '" class="" /></span></div>';
                //         } else {
                //             defaultHtml = '<div class="set_fn " data-type="add" data-for="gate_in"><span class=""><img src="' + pen + '" class="" /> Set</span></div>';
                //         }
                //         return (
                //             defaultHtml
                //         );
                //     },
                // },
                // {
                //     text: 'Gaorder_note Out', filtertype: 'textbox', width: '6%', cellclassname: '', datafield: 'gate_out',
                //     cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, data) {
                //         if (cellValue) {
                //             defaultHtml = '<div  style="margin-top: 12px; margin-left:5px">' + cellValue.slice(0, 16) + '<span class="screen" data-type="edit" data-for="gate_out"><img src="' + pen + '" class="" /></span></div>';
                //         } else {
                //             defaultHtml = '<div class="set_fn " data-type="add" data-for="gate_out"><span class=""><img src="' + pen + '" class="" /> Set</span></div>';
                //         }
                //         return (
                //             defaultHtml
                //         );
                //     },
                // },

                // { text: 'Order ID', datafield: 'order_no', filterable: true, hidden: true },
                // { text: 'ETA Truck', filtertype: 'textbox', datafield: 'eta_truck', width: '8%', cellclassname: '', },
            ];
            const torColumns = [
                {
                    text: 'Order No.',
                    datafield: 'order_no',
                    width: '8%',
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, rowData) => {
                        const order_no = rowData.order_no ?? '';
                        return `<div class="order-number-cell mt-3"
                                data-order="${cellValue}"
                                data-ordertype="${order_no}">
                                ${order_no}
                                </div>`;
                    }

                },
                { text: 'Trucker Name', datafield: 'trucker_name', width: '8%' },
                {
                    text: 'Loading Advice', datafield: 'loading_advice', width: '8%',
                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        if (cellValue) { //  + process.env.REACT_APP_BASE_URL_IMAGE + 'TruckMonitor/'
                            defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
                        }
                        return (
                            defaultHtml
                        );
                    },
                },
                { text: 'Truck No.', datafield: 'truck_no', width: '8%' },
                { text: 'Truck Date', datafield: 'truck_date', cellsformat: 'dd-MM-yyyy', filtertype: 'date', width: '8%' },
                { text: 'Docs', datafield: 'doc_status', width: '8%' },
                {
                    text: 'Pickup Status', datafield: 'pickup_status', width: '8%',
                    cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties) => {
                        if (value && Array.isArray(value)) {
                            // Generate multiple divs for each item in the array
                            const content = value
                                .map((item) =>
                                    `<div class="${item.color_status || ''}">${item.status || ''}</div>`
                                ).join(''); // Combine all divs into a single string

                            return `<div class="stats_view">${content}</div>`;
                        }
                        // Fallback if value is not an array or empty
                        return defaulthtml;
                    }
                },
                {
                    text: 'Order Type', datafield: 'order_type', width: '8%',

                    cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                        if (cellValue === 'Loading') {
                            return '<div class="m_loading"> <img src="' + Loading + '"/> ' + cellValue + ' </div>';
                        } else if (cellValue === 'Unloading') {
                            return '<div class="m_unloading"><img src="' + Unloading + '"/> ' + cellValue + ' </div>';
                        } else {
                            return '';
                        }
                    },
                },
                { text: 'ETA Truck', datafield: 'eta_truck', width: '8%' },

                // { text: 'Carrier Name', datafield: 'carrier_name', width: '8%' },
                // { text: 'Flight No.', datafield: 'flight_number', width: '8%' },
                // { text: 'Loading Station', datafield: 'loading_station', width: '8%' },
                // { text: 'Loading Location', datafield: 'loading_location', width: '8%' },
                // { text: 'Unloading Station', datafield: 'unloading_station', width: '8%' },
                // { text: 'Unloading Location', datafield: 'unloading_location', width: '8%' },
                // Add more columns as needed
            ];
            const torGrids = {};
            const torrowdetails = (index, parentElement, gridElement, record) => {
                const torGridContainer = parentElement.children[0];
                const parentRowId = record.uid.toString();
                torGrids[parentRowId] = torGridContainer;
                parentElement.addEventListener('click', (event) => {
                    const target = event.target;
                    if (window.$(target).hasClass('jqx-icon-arrow-right')) {
                        event.stopPropagation();
                    }
                });
                const id = record.uid.toString();
                const uldGrid = dataAdapter.loadedData.Rows[id]?.orders;
                const torSource = {
                    datatype: 'json',
                    id: 'shipmentChildID',
                    datafields: [
                        { name: 'id', type: 'string' },
                        { name: 'order_no', type: 'string' },
                        { name: 'trucker_name', type: 'string' },
                        { name: 'loading_advice', type: 'string' },
                        { name: 'truck_number', type: 'string' },
                        { name: 'truck_date', type: 'date' },
                        { name: 'docs', type: 'date' },
                        { name: 'pickup_status', type: 'string' },
                        { name: 'order_type', type: 'string' },
                        { name: 'eta_truck', type: 'string' },
                        { name: 'truck_no', type: 'string' },
                        { name: 'truck_date', type: 'string' },
                    ],
                    localdata: uldGrid,
                }
                const torDataAdapter = new window.$.jqx.dataAdapter(torSource);
                const awbColumns = [
                    { text: 'Airway Bill', datafield: 'airway_bill', width: '8%' },
                    {
                        text: 'Order Type', datafield: 'order_type', width: '8%',

                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            if (cellValue === 'Loading') {
                                return '<div class="m_loading"> <img src="' + Loading + '"/> ' + cellValue + ' </div>';
                            } else if (cellValue === 'Unloading') {
                                return '<div class="m_unloading"><img src="' + Unloading + '"/> ' + cellValue + ' </div>';
                            } else {
                                return '';
                            }
                        },
                    },
                    {
                        text: 'Pickup Status', datafield: 'pickup_status', width: '12%',
                        cellsrenderer: (row, columnfield, value, defaulthtml, columnproperties) => {
                            if (value && Array.isArray(value)) {
                                const content = value
                                    .map((item) =>
                                        `<div class="${item.color_status || ''}">${item.status || ''}</div>`
                                    ).join('');

                                return `<div class="stats_view">${content}</div>`;
                            }
                            return defaulthtml;
                        }
                    },
                    { text: 'Pcs', datafield: 'pieces', width: '5%' },
                    { text: 'RCF', datafield: 'rcf', width: '5%' },
                    { text: 'MAN', datafield: 'man', width: '5%' },
                    { text: 'MSCA', datafield: 'msca', width: '5%' },
                    { text: 'Package', datafield: 'package', width: '5%' },
                    { text: 'ULD No.', datafield: 'uld_number', width: '8%' },
                    { text: 'Weight', datafield: 'weight', width: '5%' },
                    { text: 'Volume', datafield: 'volume', width: '4%' },
                    { text: 'LM', datafield: 'lm', width: '4%' },
                    { text: 'Nature of Goods', datafield: 'nature_of_goods', width: '8%' },
                ];
                const awbGrids = {};
                const awbrowdetails = (index, parentElement, gridElement, record) => {
                    const awbGridContainer = parentElement.children[0];
                    const parentRowId = record.uid.toString();
                    awbGrids[parentRowId] = awbGridContainer;
                    parentElement.addEventListener('click', (event) => {
                        const target = event.target;
                        if (window.$(target).hasClass('jqx-icon-arrow-right')) {
                            event.stopPropagation();
                        }
                    });
                    const id = record.uid.toString();
                    const uldGrid = torDataAdapter.loadedData[id]?.awb;
                    const awbSource = {
                        datatype: 'json',
                        id: 'shipmentChildID',
                        datafields: [
                            { name: 'id', type: 'string' },
                            { name: 'airway_bill', type: 'string' },
                            { name: 'pickup_status', type: 'string' },
                            { name: 'pieces', type: 'string' },
                            { name: 'rcf', type: 'string' },
                            { name: 'man', type: 'string' },
                            { name: 'msca', type: 'string' },
                            { name: 'package', type: 'string' },
                            { name: 'uld_number', type: 'string' },
                            { name: 'weight', type: 'string' },
                            { name: 'volume', type: 'string' },
                            { name: 'lm', type: 'string' },
                            { name: 'nature_of_goods', type: 'string' },
                            { name: 'order_no', type: 'string' },
                            { name: 'truck_no', type: 'string' },
                            { name: 'truck_date', type: 'string' },
                            { name: 'order_type', type: 'string' },
                        ],
                        localdata: uldGrid,
                    }
                    const awbDataAdapter = new window.$.jqx.dataAdapter(awbSource);
                    const awbGridOptions = {
                        width: '100%',
                        pageable: false,
                        sortable: false,
                        autoheight: false,
                        height: (6 * 45),
                        selectionmode: '',
                        source: awbDataAdapter,
                        filterable: false,
                        columns: awbColumns,
                        rowdetails: true,
                        rowsheight: 45,
                        showemptyrow: false,
                        ready: function () {
                            const rows = window.$(awbGridContainer).jqxGrid('getrows');
                            for (let i = 0; i < rows.length; i++) {
                                const rowid = i;
                                const row = rows[i];
                                window.$(awbGridContainer).jqxGrid('setcellvalue', row.uid, 'uid', rowid);
                                window.$(awbGridContainer).jqxGrid('updaterow', rowid, row);
                                window.$(awbGridContainer).find(`[role="row"][row-id="${row.uid}"]`).attr('row-id', rowid);
                            }
                        },
                    };
                    window.$(awbGridContainer).jqxGrid(awbGridOptions);
                };
                const torGridOptions = {
                    width: '100%',
                    pageable: false,
                    sortable: false,
                    autoheight: false,
                    height: (8 * 45),
                    selectionmode: '',
                    source: torDataAdapter,
                    filterable: false,
                    columns: torColumns,
                    rowdetails: true,
                    rowsheight: 45,
                    showemptyrow: false,
                    initrowdetails: awbrowdetails,
                    rowdetails: true,
                    rowdetailstemplate: {
                        rowdetails: '<div id="awbGrid" style="margin: 10px;"></div>',
                        rowdetailsheight: (6 * 45),
                        rowdetailshidden: true,
                    },
                    ready: function () {
                        const rows = window.$(torGridContainer).jqxGrid('getrows');
                        for (let i = 0; i < rows.length; i++) {
                            const rowid = i;
                            const row = rows[i];
                            window.$(torGridContainer).jqxGrid('setcellvalue', row.uid, 'uid', rowid);
                            window.$(torGridContainer).jqxGrid('updaterow', rowid, row);
                            window.$(torGridContainer).find(`[role="row"][row-id="${row.uid}"]`).attr('row-id', rowid);
                        }
                    },
                };
                window.$(torGridContainer).jqxGrid(torGridOptions);
            };
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                enabletooltips: true,
                editable: false,
                selectionmode: '', // checkbox
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
                initrowdetails: torrowdetails,
                rowdetails: true,
                rowdetailstemplate: {
                    rowdetails: '<div id="torGrid" style="margin: 10px;"></div>',
                    rowdetailsheight: (8 * 45),
                    rowdetailshidden: true,
                },
                ready: function () {
                    localStorgeFilter();
                },
            };
            window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
            window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRefs[activeTab].current).off('cellclick');
            window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                if (![0, 3].includes(event.args.columnindex)) {
                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                    }
                }
            });
            window.$(gridRefs[activeTab].current).on('click', '.set_fn, .screen', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);
                const clickedFor = window.$(this).data('for');
                const clickedType = window.$(this).data('type');
                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        let dateTime = "";
                        if (clickedFor == "gate_in") {
                            dateTime = rowData.gate_in;
                        } else if (clickedFor == "gate_out") {
                            dateTime = rowData.gate_out;
                        }
                        const rId = rowData.uid
                        const nestedData = dataAdapter.loadedData.Rows[rId].orders;
                        const orderIds = nestedData.map(item => item.order_id);
                        const transformData = { ...rowData, order_ids: orderIds, set_type: clickedFor, date_time: dateTime }
                        setClickedFor(clickedFor);
                        setClickedType(clickedType);
                        setRowData(transformData);
                        setSchdlModal(true);
                    } else {
                        console.error('No data found for the given row index.');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }
            });
            window.$(gridRefs[activeTab].current).on('click', '.order-number-cell', function () {
                const orderNumber = window.$(this).data('order');
                const orderType = window.$(this).data('ordertype');
                const filter = [{
                    datafield: "order_no",
                    filters: [{
                        condition: "CONTAINS",
                        operator: 1,
                        value: orderNumber
                    }]
                }];
                localStorage.setItem("ovFilter", JSON.stringify(filter));
                localStorage.setItem("Htab", "orders");
                localStorage.setItem("orderTypeTab", orderType);
                window.location.reload();
            });
        }
    }, [gridData]);
    function localStorgeFilter() {
        let savedFilters = localStorage.getItem('vvFilter');
        if (savedFilters) {
            savedFilters = JSON.parse(localStorage.getItem('vvFilter'));
            savedFilters.forEach(element => {
                const filterValue = element.filters[0].value;
                if (filterValue !== null && filterValue !== undefined) {
                    const filterGroup = new window.$.jqx.filter();
                    const filterCondition = element.filters[0].condition ?? "CONTAINS"; // Adjust the condition as needed
                    const filter = filterGroup.createfilter("stringfilter", filterValue, filterCondition);
                    filterGroup.addfilter(1, filter);
                    window.$(gridRefs[activeTab].current).jqxGrid("addfilter", element.datafield, filterGroup);
                }
            });
            window.$(gridRefs[activeTab].current).jqxGrid("applyfilters");
            setApplyFilter(false);
        }
    };
    const resetFilters = () => {
        window.$(gridRefs[activeTab]?.current).jqxGrid('clearfilters');
        localStorage.removeItem('vvFilter');
    };
    const handleCloseClick = () => {
        setSelectedRowData(null);
    };

    // FILE UPLOAD START
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [base64Files, setBase64Files] = useState([]);
    const [schdlModal, setSchdlModal] = useState(false);
    const [clickedType, setClickedType] = useState();
    const [clickedFor, setClickedFor] = useState();
    const [rowData, setRowData] = useState();
    const [changedData, setChangedData] = useState({
        getInOut: ''
    });


    // const imageModalUpload = (id) => {
    //     setSelectedRowId(id);
    //     setShowModalUpload(true)
    //     setFiles([])
    // }

    const imageModalUpload = (id) => {
        const selectedRowFiles = gridSelect.find(item => item.uid === id)?.files || [];
        setFiles(selectedRowFiles);
        setSelectedRowId(id); // Store the ID of the selected row
        setShowModalUpload(true);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        base64Files.splice(index, 1);
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }
    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                // filesWithBase64.push({ file, base64: reader.result });
                filesWithBase64.push({ "base64": reader.result, "file_name": file.name });
                if (filesWithBase64.length === selectedFiles.length) {
                    // setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => obj.file)]);
                    // setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => obj.base64)]);
                    setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                    setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const imageUpload = () => {
        setGridSelect(prevGridSelect =>
            prevGridSelect.map(item => {
                if (item.uid === selectedRowId) {
                    return { ...item, files: files, base64Files: base64Files };
                }
                return item;
            })
        );
        setShowModalUpload(false);
    };

    const movementHistoryClick = () => {
        localStorage.removeItem('MHistory');
        const storageData = {
            ULD: selectedRowData,  // ULD Details section
            Form: {}  // Empty form section
        };
        localStorage.setItem('MHistory', JSON.stringify(storageData));
        // localStorage.setItem('tab', 'operations');
        window.location.href = '/ULDControl/MovementHistory'
    };
    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setRowData((prev) => ({
            ...prev,
            [name]: value
        }));

    };
    const updateTime = async () => {
        console.log("rowData", rowData);

        const res = await withRFSToken.post('monitor/vehicle-get-in-out-set', rowData)
            .then(function (res) {
                if (res.data.response_code == 200) {
                    window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
                    setSchdlModal(false);
                }
            });
    };
    // FILE UPLOAD END
    return (
        <>
            {/* {console.log('selectedRowData', selectedRowData)} */}
            <div className="maindiv">
                <div className='trashdonload'>
                    {/* {!isLoading && <div ref={gridRef} className='bookinggrid' ></div>} */}
                    <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
                        <Tab eventKey="All" title={<span>All </span>} className='moveto'>
                            {filterApplied ? <><div className='clear_filter' style={{ left: '18px' }}><Button onClick={resetFilters}>Reset <FontAwesomeIcon icon={faRotateRight} /></Button></div></> : <></>}
                            {/* <Loader isLoading={isLoading} /> */}
                            {!isLoading && <>
                                {/* {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>} */}
                                <div ref={gridRefs.All} className='bookinggrid' ></div>
                            </>
                            }
                            {/* <div ref={gridRefs.Active} className='bookinggrid' ></div> */}
                        </Tab>
                        <Tab eventKey="Loading" title={<span>Loading </span>} className='moveto'>
                            {filterApplied ? <><div className='clear_filter' style={{ left: '18px' }}><Button onClick={resetFilters}>Reset <FontAwesomeIcon icon={faRotateRight} /></Button></div></> : <></>}
                            {/* <Loader isLoading={isLoading} /> */}
                            {/* {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>} */}
                            {!isLoading && <div ref={gridRefs.Loading} className='bookinggrid' ></div>}
                            {/* <div ref={gridRefs.Archived} className='bookinggrid' ></div> */}
                        </Tab>
                        <Tab eventKey="Unloading" title={<span>Unloading </span>} className='moveto'>
                            {filterApplied ? <><div className='clear_filter' style={{ left: '18px' }}><Button onClick={resetFilters}>Reset <FontAwesomeIcon icon={faRotateRight} /></Button></div></> : <></>}
                            {/* <Loader isLoading={isLoading} /> */}
                            {/* {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>} */}
                            {!isLoading && <div ref={gridRefs.Unloading} className='bookinggrid' ></div>}
                            {/* <div ref={gridRefs.Archived} className='bookinggrid' ></div> */}
                        </Tab>
                        <Tab eventKey="Archived" title={<span>Archived </span>} className='moveto'>
                            {filterApplied ? <><div className='clear_filter' style={{ left: '18px' }}><Button onClick={resetFilters}>Reset <FontAwesomeIcon icon={faRotateRight} /></Button></div></> : <></>}
                            {/* <Loader isLoading={isLoading} /> */}
                            {/* {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>} */}
                            {!isLoading && <div ref={gridRefs.Archived} className='bookinggrid' ></div>}
                            {/* <div ref={gridRefs.Archived} className='bookinggrid' ></div> */}
                        </Tab>
                    </Tabs>
                </div>
                {selectedRowData && (
                    <div className='SecondDiv mt-45'>
                        <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
                        <div className='girddtals_header'>
                            <h3>
                                {selectedRowData.vehicle_no} &nbsp; <span>{selectedRowData.status}</span>
                            </h3>
                            <div className='d-flex actbtn'>

                                <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                                {/* <Dropdown>
                                    <Dropdown.Toggle variant="light" id="dropdown-basic" >
                                        <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item >option</Dropdown.Item>
                                        <Dropdown.Item >option</Dropdown.Item>
                                        <Dropdown.Item >option</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown> */}

                            </div>

                        </div>
                        <div className='movment_history my-2'>
                            <h3>Movement Vehicle</h3> <Link to='#'>View All</Link>
                        </div>
                        <div className='mb-3'>
                            <div className='onging_vehicle mb-2'>
                                <div className='rcf_location'><FontAwesomeIcon icon={faLocationDot} /></div>
                                <div className='d-flex justify-content-between borderh align-items-center'>
                                    <div>
                                        <h3>DNATA - AMS</h3>
                                        <p>Loading - 241163577</p>
                                    </div>
                                    <div className='rcf_details'><Link><FontAwesomeIcon icon={faEye} /></Link></div>
                                </div>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div>
                                        <p>Scheduled - <b>26 Nov 15:00 <span></span></b> CEST</p>
                                        <p>Actual - <b>26 Nov 15:00 <span></span></b> CEST</p>
                                    </div>
                                    <div className='rfp'><span><FontAwesomeIcon icon={faCircleCheck} /> RFP</span></div>
                                </div>
                            </div>

                            <div className='onging_vehicle mb-2'>
                                <div className='rcf_location'><FontAwesomeIcon icon={faLocationDot} /></div>
                                <div className='d-flex justify-content-between borderh align-items-center'>
                                    <div>
                                        <h3>WFS - AMS</h3>
                                        <p>Loading - 241163577</p>
                                    </div>
                                    <div className='rcf_details'><Link><FontAwesomeIcon icon={faEye} /></Link></div>
                                </div>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div>
                                        <p>Scheduled - <b>26 Nov 15:00 <span></span></b> CEST</p>
                                        <p>Actual - <b>26 Nov 15:00 <span></span></b> CEST</p>
                                    </div>
                                    <div className='rcf'><span><FontAwesomeIcon icon={faSpinner} /> RCF</span></div>
                                </div>
                            </div>

                            <div className='onging_vehicle mb-2'>
                                <div className='rcf_location'><FontAwesomeIcon icon={faLocationDot} /></div>
                                <div className='d-flex justify-content-between borderh align-items-center'>
                                    <div>
                                        <h3>Challenge Handling - LGG</h3>
                                        <p>Loading - 241163577</p>
                                    </div>
                                    <div className='rcf_details'><Link><FontAwesomeIcon icon={faEye} /></Link></div>
                                </div>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div>
                                        <p>Scheduled - <b>26 Nov 15:00 <span></span></b> CEST</p>
                                        <p>Actual - </p>
                                    </div>
                                    <div className='rfp'><span><FontAwesomeIcon icon={faCircleCheck} /> RFP</span></div>
                                </div>
                            </div>

                            <div className='onging_vehicle'>
                                <div className='rcf_location'><FontAwesomeIcon icon={faLocationDot} /></div>
                                <div className='d-flex justify-content-between borderh align-items-center'>
                                    <div>
                                        <h3>WFS - LGG</h3>
                                        <p>Loading - 241163577</p>
                                    </div>
                                    <div className='rcf_details'><Link><FontAwesomeIcon icon={faEye} /></Link></div>
                                </div>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div>
                                        <p>Scheduled - <b>26 Nov 15:00 <span></span></b> CEST</p>
                                        <p>Actual - </p>
                                    </div>
                                    <div className='rcf'><span><FontAwesomeIcon icon={faSpinner} /> RCF</span></div>
                                </div>
                            </div>
                        </div>
                        <div className='movment_history'>
                            <h3>Movement History</h3> <Link to='#' onClick={movementHistoryClick}>View All</Link>
                        </div>
                        <div className='movment_list'>
                            <ul>
                                {/* {selectedRowData && selectedRowData.movement_history.slice(0, 5).map((history, index) => ( */}
                                <li>
                                    <span className='movem'>sada</span>
                                    <span className='mvdate'>asdsad</span>
                                    <Link to='#' >Details</Link> {/* onClick={() => handleDetailsClick(history)} */}
                                </li>
                                {/* ))} */}
                            </ul>
                        </div>
                        <ImageUpload
                            ref={imageUploadRef}
                            attachable_type={"rfs_vehicle"}
                            attachable_id={selectedRowData.order_id}
                            attachments={selectedRowData.attachments}
                        // onDeleteSuccess={() => loadDetails(selectedRowData.order_id)}
                        />
                        <ActivityComments
                            commentable_type={"rfs_vehicle"}
                            commentable_id={selectedRowData.order_id}
                            allactivities={selectedRowData.activities}
                        // onReloadDetails={() => loadDetails(selectedRowData.order_id)}
                        />
                    </div>
                )}
            </div>
            <Modal show={schdlModal} onHide={() => setSchdlModal(false)} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>{clickedFor === 'gate_in' ? 'Gate In' : clickedFor === 'gate_out' ? 'Gate  Out' : ''}</h3>
                    <p>{clickedType === 'edit' ? 'Update' : clickedType === 'add' ? 'Add' : ''} {clickedFor === 'gate_in' ? 'Gate In' : clickedFor === 'gate_out' ? 'Gate  Out' : ''} Data</p>
                    <div className="mt-3">
                        <Form.Group className="mb-2 vehicle_gatein" controlId="exampleForm.ControlInput1">
                            <p> <span>Vehicle No:</span> {rowData?.vehicle_no}</p>
                            <p><span>Driver Name:</span>  {rowData?.driver_name}</p>
                            <p><span>Date:</span>  {rowData?.date}</p>
                        </Form.Group>
                        <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
                            <Form.Label>{clickedFor === 'gate_in' ? 'Gate In' : clickedFor === 'gate_out' ? 'Gate  Out' : ''}:</Form.Label>
                            <input type="datetime-local" name="date_time" className='form-control' value={rowData?.date_time} onChange={handleChange} placeholder={clickedFor === 'gate_in' ? 'Gate In' : clickedFor === 'gate_out' ? 'Gate  Out' : ''} />
                        </Form.Group>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="primary" onClick={updateTime}>
                            Update Status
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default VehicleView;